import React from "react";
// import DonutChartReact from "../../../components-react/DonutChartReact";

// const generateDonutOptions = (gyminfo) => {
//   const targetAchieved = parseFloat(gyminfo?.total_sale_value || 0);
//   const totalTarget = parseFloat(gyminfo?.total_target || 0);
//   const targetAchievedPercentage =
//     totalTarget !== 0 ? (targetAchieved / totalTarget) * 100 : 0;
//   const totalPercentage = 100 - targetAchievedPercentage;

//   const totalAbsent = parseFloat(gyminfo?.total_absent || 0);
//   const totalTrainer = parseFloat(gyminfo?.total_trainer || 0);
//   const totalAbsentPercentage =
//     totalTrainer !== 0 ? (totalAbsent / totalTrainer) * 100 : 0;
//   const allTotalAbsentPercentage = 100 - totalAbsentPercentage;

//   return clickedCard === "attendance"
//     ? {
//         series: [totalAbsentPercentage, allTotalAbsentPercentage],
//         options: {
//           colors: ["#F13434", "lightgrey"],
//           labels: ["Absent", "Total"],
//           chart: {
//             type: "donut",
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           plotOptions: {
//             pie: {
//               donut: {
//                 labels: {
//                   show: true,
//                   name: {
//                     show: true,
//                     fontSize: "22px",
//                     fontFamily: "DM Sans",
//                     fontWeight: 600,
//                     color: undefined,
//                     offsetY: -10,
//                     formatter: function (val) {
//                       return val;
//                     },
//                   },
//                   value: {
//                     show: true,
//                     fontFamily: "DM Sans",
//                     fontWeight: 500,
//                     fontSize: "15px",
//                     color: undefined,
//                     offsetY: 16,
//                     formatter: function (val) {
//                       return val;
//                     },
//                   },
//                   total: {
//                     show: true,
//                     showAlways: false,
//                     label: totalTrainer || 0,
//                     fontFamily: "DM Sans",
//                     fontWeight: 700,
//                     fontSize: "24px",
//                     color: "#171717",
//                     formatter: function (w) {
//                       return "Trainers";
//                     },
//                   },
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           responsive: [
//             {
//               breakpoint: 480,
//               options: {
//                 chart: {
//                   width: 200,
//                 },
//               },
//             },
//           ],
//         },
//       }
//     : {
//         series: [
//           parseFloat(targetAchievedPercentage).toFixed(),
//           totalPercentage,
//         ],
//         options: {
//           colors: ["#0A701B", "lightgrey"],
//           labels: ["Target Achieved", "Total"],
//           chart: {
//             type: "donut",
//           },
//           dataLabels: {
//             enabled: false,
//           },
//           plotOptions: {
//             pie: {
//               donut: {
//                 labels: {
//                   show: true,
//                   name: {
//                     show: true,
//                     fontSize: "22px",
//                     fontFamily: "DM Sans",
//                     fontWeight: 600,
//                     color: undefined,
//                     offsetY: -10,
//                     formatter: function (val) {
//                       return val;
//                     },
//                   },
//                   value: {
//                     show: true,
//                     fontFamily: "DM Sans",
//                     fontWeight: 500,
//                     fontSize: "15px",
//                     color: undefined,
//                     offsetY: 16,
//                     formatter: function (val) {
//                       return val;
//                     },
//                   },
//                   total: {
//                     show: true,
//                     showAlways: false,
//                     label: parseFloat(targetAchievedPercentage).toFixed(),
//                     fontFamily: "DM Sans",
//                     fontWeight: 700,
//                     fontSize: "24px",
//                     color: "#171717",
//                     formatter: function (w) {
//                       return "";
//                     },
//                   },
//                 },
//               },
//             },
//           },
//           legend: {
//             show: false,
//           },
//           responsive: [
//             {
//               breakpoint: 480,
//               options: {
//                 chart: {
//                   width: 200,
//                 },
//               },
//             },
//           ],
//         },
//       };
// };

const PiChartData = ({ clickedCard, gymsData, setClickedCardValue }) => {
  return (
    <div className="chartsGridSystem">
      {gymsData?.length > 0 ? (
        <>
          {gymsData.map((gyminfo, index) => {
            return (
              <div
                className="chartGridBox"
                style={{
                  cursor:
                    clickedCard === "attendance" ? "pointer" : "not-allowed",
                }}
                key={index}
                onClick={() =>
                  clickedCard === "attendance"
                    ? setClickedCardValue((prevs) => ({
                      ...prevs,
                      cardValueModal: true,
                      cardValue: gyminfo?.gym_id,
                    }))
                    : null
                }
              >
                <p className="chartHeading">{gyminfo.gym_name || "NA"}</p>
                <div className="donutChart">
                  {clickedCard === "attendance" ? (
                    <span className="total-nfo">
                      {gyminfo?.total_trainer || 0} Trainers
                    </span>
                  ) : (
                    <span className="total-nfo">
                      {parseFloat(gyminfo?.achievement_percentage || 0)?.toFixed() || 0} % Completed
                    </span>
                  )}
                  {/* <DonutChartReact options={generateDonutOptions(gyminfo)} /> */}
                </div>
                {clickedCard === "attendance" ? (
                  <span className="absentCount">
                    {gyminfo?.total_absent || 0} Absent
                  </span>
                ) : (
                  <p className="targetData">
                    ₹{gyminfo?.total_sale_value || "0"}
                    <span className="total">
                      /{gyminfo?.total_target || "0"}
                    </span>
                  </p>
                )}
              </div>
            );
          })}
        </>
      ) : (
        <span className="noDataFound">No Data Found!</span>
      )}
    </div>
  );
};

export default PiChartData;
